import { render, staticRenderFns } from "./SettingNotification.vue?vue&type=template&id=33cb77f6"
import script from "./SettingNotification.vue?vue&type=script&lang=js"
export * from "./SettingNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports